import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAlert } from "../components/AlertContext";
import { PlatformContext } from "../components/Platform/PlatformContext";

const server_url = process.env.REACT_APP_BACKEND_URL;

const ResetPassword: React.FC = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [accessToken, setAccessToken] = useState<string | null>(null); // To store the extracted token
  const { showAlert } = useAlert();
  const navigate = useNavigate();
  const platform = React.useContext(PlatformContext);
  const isMobile = !platform?.isDesktop;

  // Extract the access_token from the URL fragment
  useEffect(() => {
    const hash = window.location.hash; // Get the fragment (e.g., #access_token=...)
    const params = new URLSearchParams(hash.slice(1)); // Remove the "#" and parse the parameters
    const token = params.get("access_token"); // Extract the access_token
    setAccessToken(token); // Store it in the state
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!accessToken) {
      showAlert("error", "Invalid or missing access token.");
      return;
    }

    if (password !== confirmPassword) {
      showAlert("error", "Passwords do not match!");
      return;
    }

    try {
      const response = await axios.post(`${server_url}/resetPassword`, {
        access_token: accessToken, // Use the extracted token
        password,
      });

      if (response.data.status) {
        // console.log("Password reset successful:", response.data);
        showAlert("success", "Password reset successfully!");
        navigate("/login"); // Redirect to login page
      } else {
        // console.log("Error resetting password:", response.data.error);
        showAlert("error", "Password reset failed: " + response.data.error);
      }
    } catch (error: any) {
      // console.log("Error resetting password:", error);
      showAlert(
        "error",
        "Password reset failed: " + (error.response?.data || error.message)
      );
    }
  };

  return (
    <div className="flex items-center justify-center h-screen bg-header-secondary">
      <form
        onSubmit={handleSubmit}
        className={"pt-6 rounded shadow-md w-full max-w-sm text-white "}
      >
        <h2 className="mb-4 text-2xl font-semibold text-center">
          Reset Password
        </h2>
        <div className="mb-4">
          <label className="block mb-1 font-semibold">New Password</label>
          <input
            type="password"
            className="w-full px-3 py-2 border rounded"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <div className="mb-6">
          <label className="block mb-1 font-semibold">
            Confirm New Password
          </label>
          <input
            type="password"
            className="w-full px-3 py-2 border rounded"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </div>
        <button
          type="submit"
          className="w-full py-2 font-semibold text-white bg-blue-500 rounded hover:bg-blue-600"
        >
          Reset Password
        </button>
      </form>
    </div>
  );
};

export default ResetPassword;
